const TrainerManagementPage = () => (
  <div className="p-8 bg-white rounded-lg shadow-xl">
    <h2 className="text-3xl font-bold text-gray-800 mb-6">
      Trainer Management
    </h2>
    <div className="mb-6">
      <h3 className="text-2xl font-semibold text-gray-700 mb-4">
        Add New Trainer
      </h3>
      <form className="space-y-2 max-w-xl">
        <div>
          <label
            htmlFor="trainerName"
            className="block text-gray-700 text-sm font-semibold mb-2"
          >
            Trainer Name:
          </label>
          <input
            type="text"
            id="trainerName"
            className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
          />
        </div>
        <div>
          <label
            htmlFor="trainerSpecialty"
            className="block text-gray-700 text-sm font-semibold mb-2"
          >
            Specialty:
          </label>
          <input
            type="text"
            id="trainerSpecialty"
            className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
          />
        </div>
        <div>
          <label
            htmlFor="trainerEmail"
            className="block text-gray-700 text-sm font-semibold mb-2"
          >
            Email:
          </label>
          <input
            type="email"
            id="trainerEmail"
            className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
          />
        </div>
        <button
          type="submit"
          className="bg-purple-600 text-white py-2 px-6 rounded-md hover:bg-purple-700 transition-colors duration-300 font-semibold"
        >
          Add Trainer
        </button>
      </form>
    </div>
    <div className="mt-8">
      <h3 className="text-2xl font-semibold text-gray-700 mb-4">
        Current Trainers
      </h3>
      <div className="overflow-x-auto">
        <table className="min-w-full bg-white border border-gray-200 rounded-lg shadow-md">
          <thead>
            <tr className="bg-gray-100 border-b border-gray-200">
              <th className="py-3 px-6 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">
                Name
              </th>
              <th className="py-3 px-6 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">
                Specialty
              </th>
              <th className="py-3 px-6 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">
                Email
              </th>
              <th className="py-3 px-6 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            <tr>
              <td className="py-4 px-6 whitespace-nowrap">Sarah Chen</td>
              <td className="py-4 px-6 whitespace-nowrap">
                Hatha, Restorative
              </td>
              <td className="py-4 px-6 whitespace-nowrap">
                sarah.c@example.com
              </td>
              <td className="py-4 px-6 whitespace-nowrap">
                <button className="text-indigo-600 hover:text-indigo-900 mr-3">
                  Edit
                </button>
                <button className="text-red-600 hover:text-red-900">
                  Delete
                </button>
              </td>
            </tr>
            <tr>
              <td className="py-4 px-6 whitespace-nowrap">David Lee</td>
              <td className="py-4 px-6 whitespace-nowrap">Vinyasa, Ashtanga</td>
              <td className="py-4 px-6 whitespace-nowrap">
                david.l@example.com
              </td>
              <td className="py-4 px-6 whitespace-nowrap">
                <button className="text-indigo-600 hover:text-indigo-900 mr-3">
                  Edit
                </button>
                <button className="text-red-600 hover:text-red-900">
                  Delete
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
);

export default TrainerManagementPage;
